<template>
  <button class="marvin-float-btn" @click="$emit('open-chat')">
    <div class="guy" :class="{ wave: waving }">
      <div class="guy-body">
        <div class="guy-eye l"></div>
        <div class="guy-eye r"></div>
      </div>
      <div class="guy-shadow"></div>
    </div>
  </button>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from "vue";

defineEmits(["open-chat"]);

const waving = ref(false);
let waveInterval = null;

onMounted(() => {
  // Periodic wave animation to attract attention
  waveInterval = setInterval(() => {
    waving.value = true;
    setTimeout(() => (waving.value = false), 1200);
  }, 12000);
});

onBeforeUnmount(() => clearInterval(waveInterval));
</script>

<style scoped>
.marvin-float-btn {
  position: fixed;
  bottom: 28px;
  right: 28px;
  width: 64px;
  height: 72px;
  border: none;
  background: none;
  z-index: 9999;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  transition: transform 0.2s;
}
.marvin-float-btn:hover { transform: translateY(-3px); }
.marvin-float-btn:hover .guy { animation: guyBob 0.8s ease-in-out infinite; }

.guy {
  display: flex;
  flex-direction: column;
  align-items: center;
  animation: guyBob 2.5s ease-in-out infinite;
}
.guy.wave { animation: guyWave 0.3s ease infinite alternate; }

.guy-body {
  width: 44px;
  height: 48px;
  background: radial-gradient(ellipse at 42% 38%, #eef0f6, #dce0ea 55%, #c5c9d6);
  border-radius: 50% 50% 46% 54% / 58% 55% 45% 42%;
  position: relative;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
}
.guy-eye {
  width: 5px;
  height: 6px;
  background: #2a2d3a;
  border-radius: 50%;
  position: absolute;
  top: 38%;
  animation: blink 4s ease infinite;
}
.guy-eye.l { left: 28%; }
.guy-eye.r { right: 28%; }

.guy-shadow {
  width: 34px;
  height: 6px;
  background: rgba(0, 0, 0, 0.12);
  border-radius: 50%;
  margin-top: 3px;
}

@keyframes guyBob {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-5px); }
}
@keyframes guyWave {
  0% { transform: translateY(0) rotate(-6deg); }
  100% { transform: translateY(-4px) rotate(6deg); }
}
@keyframes blink {
  0%, 42%, 44%, 100% { transform: scaleY(1); }
  43% { transform: scaleY(0.1); }
}
</style>
